import * as Form from '../../../Form';
import { LegalComplianceSectionBase } from '../../../dapp-form/sections/LegalComplianceSectionBase';
import type { DashboardDetailsInputChangeEvent, FormState } from '../types';

interface LegalComplianceSectionProps {
  formData: FormState;
  onInputChange: (event: DashboardDetailsInputChangeEvent) => void;
}

export function LegalComplianceSection({
  formData,
  onInputChange,
}: LegalComplianceSectionProps) {
  return (
    <LegalComplianceSectionBase
      legalUrlFields={
        <>
          <Form.UrlInput
            label="Terms of Use"
            explanation="Public link to your app's consumer-facing Terms of Use"
            name="licenseUrl"
            placeholder="https://"
            defaultValue={formData.licenseUrl}
            onChange={onInputChange}
            reachabilityMode="changed"
            validateHttps={true}
          />
          <Form.UrlInput
            label="Privacy Policy"
            explanation="Public link to your app's consumer-facing Privacy Policy explaining data collection and protection."
            name="privacyPolicyUrl"
            placeholder="https://"
            defaultValue={formData.privacyPolicyUrl}
            onChange={onInputChange}
            reachabilityMode="changed"
            validateHttps={true}
          />
        </>
      }
    />
  );
}
